// extracted by mini-css-extract-plugin
export var boxItems = "_5z-1";
export var boxItemsLg = "_5z-2";
export var button = "_5z-7";
export var buttonHoverless = "_5z-9";
export var buttonLg = "_5z-8";
export var filterGroupBox = "_5z-0";
export var icon = "_5z-3";
export var iconSecondary = "_5z-6";
export var iconWrapper = "_5z-4";
export var iconWrapperLg = "_5z-5";
export var truncatedLabel = "_5z-a";